import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import { Box } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreButtonIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonIcon";
import CoreCard from "../../../app/core/components/CoreCard/CoreCard";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import { LOGO_UPLOAD_MAX_SIZE } from "../../../utils/constants";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import { useGetCommercialistaQuery } from "../../api/admin/gestisciCommercialistiApi";
import {
  useAssociaAdminMutation,
  useDeleteStudioMutation,
  useGetStudioIdQuery,
  useSaveStudioMutation,
} from "../../api/admin/gestisciStudioApi";
import AssociateTableOperator from "./AssociateTableOperator";
import FormStudio from "./FormStudio";
import { doUploadLogoFileOnS3, getUploadLogoURL } from "./gestisciStudioSlice";
import UserFilter from "../../../app/core/components/UserFilter/UserFilter";
import { useTranslation } from "react-i18next";
import CoreIconDelete from "../../../app/core/components/CoreIconDelete/CoreIconDelete";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack";

const SchedaStudio = () => {
  const baseColors = useSelector((state) => state.app.appConfig.assets.colors);
  const { t } = useTranslation();
  const [selectedCommercialista, setSelectedCommercialista] = useState();
  const [options, setOptions] = useState([]);
  const [showConfirmUserDialog, setShowConfirmUserDialog] = useState(false);
  const [isNewLogoDropped, setIsNewLogoDropped] = useState(false);
  const [debouncedInputOperatorValue, setDebouncedInputOperatorValue] =
    useState("");
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [formData, setFormData] = useState({});
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const [deleteStudio] = useDeleteStudioMutation();
  const [saveStudio, { isLoading: isSaveLoading }] = useSaveStudioMutation();
  const [associaAdmin, { isLoading: isAssociaLoading }] =
    useAssociaAdminMutation();

  const { data, isLoading, isFetching } = useGetStudioIdQuery(params.id);
  const {
    data: commercialisti,
    isLoading: isCommercialistiLoading,
    isFetching: isCommercialistiFetching,
  } = useGetCommercialistaQuery({ page });

  useEffect(() => {
    if (data && data?.Data) {
      setFormData({
        id: data?.Data?.id,
        name: data?.Data?.name || "",
        address: data?.Data?.address || "",
        vat: data?.Data?.vat || "",
        email: data?.Data?.email || "",
        phoneNumber: data?.Data?.phoneNumber || "",
        website: data?.Data?.website || "",
        dropLogo: data?.Data?.logoImageUrl,
        description: data?.Data?.description || "",
        primaryColor: data?.Data?.primaryColor || baseColors?.primaryColor,
        secondaryColor:
          data?.Data?.secondaryColor || baseColors?.secondaryColor,
      });
    }
  }, [data, baseColors]);

  useEffect(() => {
    const isValidation =
      commercialisti && commercialisti.Data && commercialisti?.Data?.items;
    if (isValidation) {
      const optionsCommercialisti = commercialisti?.Data?.items.map((el) => ({
        Nome: el.name,
        Cognome: el.surname,
      }));

      setOptions(optionsCommercialisti);
    }
  }, [commercialisti]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSelect = (event) => {
    const selectedCommercialistaName = event.target.value;
    const selectedCommercialistaData = commercialisti?.Data?.items.find(
      (user) => user.name + " " + user.surname === selectedCommercialistaName
    );
    setSelectedCommercialista(selectedCommercialistaData);
  };

  const handleDeleteStudio = () => {
    setShowConfirmUserDialog(true);
  };

  const handleCloseDialod = () => {
    setShowConfirmUserDialog(false);
  };

  const handleConfermDialog = () => {
    deleteStudio({ id: data.Data.id }).then((res) => {
      if (res?.data?.Result === 1) {
        toast.success(`${t("StudioDeleted")}`);
        handleCloseDialod();
        navigate(-1);
      } else {
        toast.error(`${t("StudioNotDeleted")}`);
      }
    });
  };

  const uploadLogo = async () => {
    let imgUrl = "";
    await dispatch(getUploadLogoURL()).then(async (res) => {
      if (res && res.payload && res.payload.Data) {
        const s3_endpoint = res.payload.Data;
        // Trova l'indice del punto interrogativo nell'URL
        const questionMarkIndex = s3_endpoint.indexOf("?");
        // Estrae la parte dell'URL prima del punto interrogativo
        const urlBeforeQuestionMark = s3_endpoint.substring(
          0,
          questionMarkIndex
        );
        imgUrl = urlBeforeQuestionMark;
        await dispatch(
          doUploadLogoFileOnS3({
            url: s3_endpoint,
            file: new Blob([formData.logoFile]),
            type: formData.logoFile.type,
          })
        ).then((res) => {
          setFormData((prevValue) => ({
            ...prevValue, // Mantieni i valori esistenti
            logoImageUrl: urlBeforeQuestionMark,
          }));
        });
      }
    });
    return imgUrl;
  };

  const handleSave = async (e) => {
    e.preventDefault();

    const id = toast.loading(`${t("Saving...")}`, {
      pauseOnFocusLoss: false,
      type: "info",
    });

    let newLogoUploaded = formData.dropLogo;
    if (isNewLogoDropped) newLogoUploaded = await uploadLogo();
    const bodyData = {
      ...formData,
      logoImageUrl: newLogoUploaded,
    };

    saveStudio(bodyData)
      .unwrap()
      .then((res) => {
        if (res.Result !== 1) {
          toast.update(id, {
            render: res.Exception || `${t("SavingNotOk")}`,
            type: "error",
            autoClose: 1500,
            isLoading: false,
          });
          return;
        }

        toast.update(id, {
          render: `${t("StudioUpdated")}`,
          type: "success",
          autoClose: 1500,
          isLoading: false,
        });
      })
      .catch(() => {
        toast.update(id, {
          render: `${t("SavingNotOk")}`,
          type: "error",
          autoClose: 1500,
          isLoading: false,
        });
      });
  };

  const handleResetColor = () => {
    setFormData((prevValue) => ({
      ...prevValue,
      primaryColor: data.Data.primaryColor,
      secondaryColor: data.Data.secondaryColor,
    }));
  };

  const handleAssociated = () => {
    const bodyData = {
      studioId: data.Data.id,
      adminId: selectedCommercialista.id,
    };

    associaAdmin(bodyData).then((res) => {
      if (res.data.Result === 1) {
        toast.success(t("OperatorAssociated"));
        setSelectedCommercialista(null);
      } else {
        toast.error(t("OperatorNotAssociated"));
      }
    });
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        const logoFile = file;
        setFormData((prevValue) => ({
          ...prevValue,
          logoFile: logoFile,
        }));

        // visualizza i dati del logo
        const reader = new FileReader();
        reader.onload = () => {
          if (file.size > LOGO_UPLOAD_MAX_SIZE) {
            toast.warning(t("InvalidFileSize"));
          } else {
            setIsNewLogoDropped(true);
            setFormData((prevValue) => ({
              ...prevValue,
              dropLogo: reader.result,
            }));
          }
        };
        reader.readAsDataURL(file);
      });
    },
    [t]
  );

  const deleteLogo = () => {
    setIsNewLogoDropped(false);
    setFormData((prevValue) => ({
      ...prevValue,
      dropLogo: "",
    }));
  };

  if (isLoading) {
    return <CoreSpinner />;
  }

  return (
    <div className="flex-row">
      <div className="flex  items-center w-full ">
        <CoreBack />
        <div className="w-11/12">
          <h2>{data?.Data?.name}</h2>
        </div>
      </div>

      <div className="flex">
        <div className="flex flex-col w-6/12 space-x-4">
          <div className="flex space-x-4 w-full">
            <CoreCard
              className="relative"
              width={"10rem"}
              height={"10rem"}
              child={
                formData.dropLogo ? (
                  <>
                    <CoreIconDelete onDelete={deleteLogo} />
                    <img
                      alt="logo"
                      src={formData.dropLogo}
                      style={{
                        maxWidth: "100px",
                        maxHeight: "100px",
                        paddingTop: "15px",
                      }}
                    />
                  </>
                ) : (
                  <Dropzone onDrop={onDrop}>
                    {({ getRootProps, getInputProps }) => (
                      <div
                        {...getRootProps()}
                        style={{
                          paddingTop: "15px",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                      >
                        <input {...getInputProps()} />

                        <Box display="flex" flexDirection="column">
                          <CoreButtonIcon
                            icon={
                              <UploadFileRoundedIcon
                                className="text-gray"
                                sx={{ fontSize: 70 }}
                              />
                            }
                          />
                        </Box>
                      </div>
                    )}
                  </Dropzone>
                )
              }
            />
          </div>
        </div>
        <div className="flex flex-col w-6/12 ">
          <h3 className="font-bold ">{t("YourColors")}</h3>
          <p className="m-0">{t("EditYourColors")}</p>
          <div className="flex w-full space-x-4 ">
            <CoreInputField
              className="w-full"
              name="primaryColor"
              label={t("PrimaryColor")}
              type="color"
              value={formData.primaryColor}
              onChange={handleInputChange}
              focused
              color="grey"
            />

            <CoreInputField
              className="w-full"
              name="secondaryColor"
              label={t("SecondaryColor")}
              type="color"
              value={formData.secondaryColor}
              onChange={handleInputChange}
              focused
              color="grey"
            />
          </div>
          <div className="text-start mt-4">
            <CoreButton
              testo="reset"
              className="btn-round-outline"
              onClick={handleResetColor}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-between  py-5 space-x-4">
        <div className="w-6/12 flex ">
          <FormStudio formData={formData} onChangeInput={handleInputChange} />
        </div>

        <div className="w-6/12 flex flex-col py-1.5">
          <h3 className="flex">
            {t("AssociatedOperators")}
            <div
              className="w-6 h-6 mx-4 rounded-3xl"
              style={{ backgroundColor: `${colorPrimary}` }}
            >
              <small className="text-white flex justify-center">
                {data?.Data?.admins?.length}
              </small>
            </div>
          </h3>
          <div className="flex justify-between w-full py-5">
            <div className="w-full">
              <UserFilter
                selectedUser={selectedCommercialista}
                setSelectedUser={(e) => {
                  setSelectedCommercialista(e);
                }}
                usersList={commercialisti?.Data?.items || []}
                setDebouncedInputUserValue={setDebouncedInputOperatorValue}
                isUsersLoading={
                  isCommercialistiLoading || isCommercialistiFetching
                }
                externalLabel={t("BriefSearchOperator")}
                externalPlaceholder={t("ExtSearchOperator")}
                externalNegativeLabel={t("NoOperatorFound")}
                isRequired
              />
            </div>
            <div>
              <CoreButtonIcon
                className={
                  !selectedCommercialista || isAssociaLoading
                    ? "text-gray-600"
                    : "text-blue-600  "
                }
                icon={
                  <PersonAddAltRoundedIcon
                    fontSize="small"
                    className={
                      !selectedCommercialista || isAssociaLoading
                        ? "text-gray-600"
                        : "text-blue-600  "
                    }
                  />
                }
                disabled={!selectedCommercialista || isAssociaLoading}
                testo={t("Associate")}
                onClick={handleAssociated}
              />
            </div>
          </div>

          <AssociateTableOperator operatorData={data?.Data?.admins} />
        </div>
      </div>

      <div className="flex justify-around py-20 ">
        <CoreButton
          className="bg-red-700 btn-round border-red-700"
          testo={t("Delete")}
          onClick={handleDeleteStudio}
          disabled={isSaveLoading}
        />
        <CoreButton
          className="btn-round"
          testo={t("Save")}
          onClick={handleSave}
          disabled={isSaveLoading}
        />
      </div>
      <CoreDialog
        open={showConfirmUserDialog}
        title={`${t("Delete")} ${t("studio")}`}
        content={`${t("StudioDeletingConfirm")} ${data?.Data?.name}?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermDialog}
        closeDialog={handleCloseDialod}
      />
    </div>
  );
};

export default SchedaStudio;
